import {lazyLoad} from "../../../utils/Loadable";
import {Box} from "@mui/material";
import {LoadingIndicator} from "../../components/LoadingIndicator";
import * as React from "react";

export const Registration = lazyLoad(

    () => import('./index'),
    module => module.Registration,
    {
        fallback: (
            <Box sx={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <LoadingIndicator/>
            </Box>
        ),
    },
);